<p-inputgroup [style.width]="width">
  <p-iconfield id="search-field">
    <p-inputicon [style.z-index]="10">
      <mat-icon [size]="20">search</mat-icon>
    </p-inputicon>
    <input
      class="w-full"
      #searchInput
      type="text"
      pInputText
      [disabled]="disabled"
      [placeholder]="placeholder ?? 'general.searchPlaceholder' | translate"
      [ngModel]="searchFilter()"
      (keyup)="searchFilter.set($event.target.value)"
      (keydown.enter)="searchInput.blur(); codeScanned(searchFilter())"
    />
    @if (busy) {
      <p-inputicon>
        <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration="1s" [style]="{ width: '20px', height: '20px' }" />
      </p-inputicon>
    }
    @if (!busy && searchInput.value) {
      <p-inputicon class="cursor-pointer" (click)="searchFilter.set('')">
        <mat-icon [size]="20">close</mat-icon>
      </p-inputicon>
    }
  </p-iconfield>
  <p-inputgroup-addon>
    <p-button [rounded]="true" [text]="true" [disabled]="disabled" (onClick)="openScanner()">
      <mat-icon color="white">barcode_scanner</mat-icon>
    </p-button>
  </p-inputgroup-addon>
</p-inputgroup>
